import axios from "axios";
import { post, put } from "../client";
import {
  ASSETS_CREATE_SIGNED_UPLOAD_URL,
  ASSETS_SAVE_CLIENT_DOCUMENTS,
  ASSETS_GET_CLIENT_DOCUMENTS,
  ASSETS_DELETE_CLIENT_DOCUMENT,
} from "../routes";

// ASSETS service
//
// Wraps the four S3-backed client-document endpoints. The upload
// flow is a 3-step dance:
//
//   1. createSignedUploadURL — backend mints presigned PUT URLs and
//      returns matching `fileMetas` (assetId + s3FilePath) per file.
//   2. PUT each file's binary directly to its presigned URL. The
//      browser does this with raw axios (no auth headers — the
//      presigned URL carries its own signature, and adding our
//      Authorization header would break the S3 signature check).
//   3. saveClientDocuments — tells the backend "these N files are
//      now in S3, store them on the user's UserBusiness record"
//      with the metadata + per-file display name + comment.
//
// `getClientDocuments` returns the documents already stored on the
// user, each enriched with a fresh signed download URL.
//
// `deleteClientDocument` removes one document by id (the S3 object
// itself is intentionally left behind by the backend — see TODO in
// the controller).
const ASSETS = {
  createSignedUploadURL: (userId, fileExtensions) =>
    post(ASSETS_CREATE_SIGNED_UPLOAD_URL, { userId, fileExtensions }),

  uploadToS3: async (presignedUrl, file) => {
    // Direct PUT to S3 with the raw File object. We deliberately
    // bypass our axios instance so no Authorization header leaks
    // into the request and breaks the presigned signature.
    const res = await axios.put(presignedUrl, file, {
      headers: { "Content-Type": file.type || "application/octet-stream" },
    });
    if (res.status !== 200) throw new Error("S3 upload failed");
    // Strip the query string — the unparametrized URL is the public
    // form, and the backend stores that.
    return presignedUrl.split("?")[0];
  },

  saveClientDocuments: (userId, files) =>
    post(ASSETS_SAVE_CLIENT_DOCUMENTS, { userId, files }),

  getClientDocuments: (userId) =>
    post(ASSETS_GET_CLIENT_DOCUMENTS, { userId }),

  deleteClientDocument: (userId, documentId) =>
    put(ASSETS_DELETE_CLIENT_DOCUMENT, { userId, documentId }),
};

export default ASSETS;
